import {
    AfterViewInit,
    OnDestroy,
    ChangeDetectorRef,
    Component,
    effect,
    ElementRef,
    Inject,
    NgZone,
    OnInit,
    ViewChild,
} from '@angular/core';
import {
    NavigationEnd,
    NavigationSkipped,
    NavigationStart,
    Router,
    RouterEvent,
} from '@angular/router';

import {
    ClinicCountryEnum,
    CountryCdEnum,
    MenuData,
    PopupConfig,
    PopupService,
    PopupType,
    Role,
    RoleEnum,
} from 'merlin-library';
import {
    LanguageSource,
    LocalizationService,
} from 'src/core/utilitites/localization.service';
import { MenuComponent } from 'merlin-library';
import { UserRole } from 'merlin-library';

import { SessionTimeoutService } from '../session-timeout/session-timeout.service';
import {
    filter,
    first,
    take,
    takeUntil
} from 'rxjs/operators';
import { RouteChangeObject, RouteChangeService } from 'merlin-library';
import { UserProfileObject, UserService } from 'merlin-library';
import { OAuthService } from 'angular-oauth2-oidc';
import { ToastrService } from 'ngx-toastr';
import { MatDialog, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatMenuTrigger } from '@angular/material/menu';
import { InteractionType, RedirectRequest } from '@azure/msal-browser';
import { environment } from 'src/environments/environment';
import {
    MsalGuardConfiguration,
    MsalService,
    MSAL_GUARD_CONFIG,
} from '@azure/msal-angular';

import { Observable, Subject } from 'rxjs';
import { LastActiveService } from '../last-active/last-active.service';
import { v4 as uuidv4 } from 'uuid';
import { ShellService } from './shell-service';
import { CoreConstants, HelperService } from 'merlin-core';
import { DOCUMENT } from '@angular/common';
import { ClinicAdminProfileService } from 'projects/clinician/src/app/clinic-admin/services/clinic-admin-profile.service';
import { MyAccountService } from 'projects/clinician/src/app/my-account/services/my-account.service';
import { ExportOptionsService } from 'projects/clinician/src/app/clinic-admin/clinic-settings/services/export-options.service';
import { CommonService } from 'projects/clinician/src/app/shared/service/common.service';


let proxy: any;
@Component({
    selector: 'app-shell',
    templateUrl: './shell.component.html',
    styleUrls: ['./shell.component.scss'],
    standalone: false
})
export class ShellComponent implements OnInit, AfterViewInit, OnDestroy {
    private destroying$ = new Subject<void>();
    msgStr: string = '';
    stringsApiCompleted = false;
    public lastActiveDate$: Observable<Date>;
    countdown$: any;
    countdownStarted = false;
    countdownSeconds = 300;
    webAppVersion: any;
    ddtVersion: any;
    vdeVersion: any;
    currentYear: any = new Date().getFullYear();
    icmDeviceAvailable: boolean = false;
    icmAiCapableDeviceAvailable: boolean = false;
    aiCountryUnlocked: boolean = false;
    rpEnabled: boolean = false;
   // clinicLanguage: any = '';
    wasLoggedInAfterRefresh: boolean = false; 

    constructor(
        private router: Router,
        private userService: UserService,
        private myAccountService: MyAccountService,
        private localizeService: LocalizationService,
        private oidcService: OAuthService,
        private sessionTimeoutService: SessionTimeoutService,
        private routeChangeService: RouteChangeService,
        private cd: ChangeDetectorRef,
        private toastrService: ToastrService,
        private helperService: HelperService,
        public dialog: MatDialog,
        @Inject(MSAL_GUARD_CONFIG)
        private msalGuardConfig: MsalGuardConfiguration,
        private msalService: MsalService,
        private elementRef: ElementRef,
        private zone: NgZone,
        private lastActiveService: LastActiveService,
        private shellService: ShellService,
        private popupService: PopupService,
        private clinicAdminService: ClinicAdminProfileService,
        private exportOptionService: ExportOptionsService,
        private commonService: CommonService,
        @Inject(DOCUMENT) private dom: Document
    ) {
        this.lastActiveDate$ = lastActiveService.lastActive$;
        this.zone.run(() => {
            this.storePrevUrl();
        });
        effect(() => {
            const lang = this.localizeService.currentLang();
            if (!lang) {
                this.stringsApiCompleted = false;
                return;
            }
            this.translateStrings();
            this.impersonateMessage = this.generateImpersonateMessage(this.userProfile.effectiveUserName, this.userProfile.customerName);
            this.stringsApiCompleted = true;

        });
    }

    private isReload(): boolean {
        const nav = performance.getEntriesByType('navigation')[0] as PerformanceNavigationTiming;
        return nav?.type === 'reload';
    }

    private hasMsalSession(): boolean {
        return this.msalService.instance.getAllAccounts().length > 0;
    }

    @ViewChild('merlinMenu') merlinMenu!: MenuComponent;
    @ViewChild('menuTrigger') menuTrigger!: MatMenuTrigger;
    menuDataSource: MenuData[] = [];

    enableSubMenu = false;
    idleState = 'NOT_STARTED';
    footerData: any = [
        {
            url: '/terms-of-use',
            link: 'label.gb.terms_cond',
            clickFunction: this.websiteTermsClick,
            dataTxKey: 'label.gb.terms_cond'
        },
        {
            url: '/terms-conditions',
            link: 'label.gb.hf_terms_cond',
            clickFunction: this.termsAndConditionsClick,
            dataTxKey: 'label.gb.hf_terms_cond'
        },
        {
            url: '/privacy-policy',
            link: 'label.gb.priv_policy',
            clickFunction: this.privacyPolicyClick,
            showClick: true,
            dataTxKey: 'label.gb.priv_policy'
        },
        {
            url: '/contact-us',
            link: 'label.gb.contact_us',
            clickFunction: this.contactUsClick,
            dataTxKey: 'label.gb.contact_us'
        },
        {
            url: '/cardio-vascular',
            link: 'www.cardiovascular.abbott',
            clickFunction: this.websiteMoreInfoClick,
            showClick: true,
            dataTxKey: ''
        },
    ];
    footerCopyRights: any = [
        { linkText: `Merlin.net\u2122 \u00A9 ${this.currentYear} Abbott` },
    ];
    fooMenuClass = '';
    fooCopyrightClass = '';
    menuClass = '';
    userName: string = '';
    firstName: string = '';
    lastName: string = '';
    isSignedOn = false;
    public role!: Role;
    _role = Role;
    timedOut = false;
    private previousUrl: string = '';
    private currentUrl: string = '';
    userJurisdiction: string = '';
    clinicCountry: string = '';
    // Flag to determine if current route is home page, used to conditionally remove #app-container id
    isHomePage: boolean = false;

    languageHelpLinks = [];

     public stringLabels = [
        "label.gb.signin",
        "label.gb.clinic_name",
        "label.gb.signedin",
        "label.gb.help",
        "leftNav.learn_more",
        "leftNav.practice_site",
        "label.gb.about",
        "label.gb.help_other_lang",
        "label.gb.signout",
        "label.gb.title.merlin.pcn"
    ];

    public labels: Record<string, string> = {};

    public impersonateMessage: any;
    private impersonateElement: HTMLElement | null = null;
    private readonly onImpersonateClick = this.redirectToBase.bind(this);

    private setSessionTimeout(lastActiveService: LastActiveService) {
        this.countdownStarted = false;
        lastActiveService.sessionExpired$.pipe(
            takeUntil(this.destroying$)
        ).subscribe((sessionExpired) => {
            if (sessionExpired && !this.countdownStarted) {
                this.countdownStarted = true;
                let count = this.countdownSeconds;
                this.countdown$ = setInterval(
                    () => {
                        count = count - 1;
                        const idleStateDate =
                            localStorage.getItem('idleStateDate');
                        if (idleStateDate) {
                            var seconds =
                                (new Date().getTime() -
                                    new Date(idleStateDate).getTime()) /
                                1000;
                            if (seconds > 10) {
                                count = count - seconds;
                                localStorage.removeItem('idleStateDate');
                            }
                        } else {
                            localStorage.setItem(
                                'idleStateDate',
                                new Date().toString()
                            );
                        }
                        this.idleState = this.ToHHMMSS(count);



                        this.cd.detectChanges();

                        if (count <= 1) {
                            clearInterval(this.countdown$);
                            localStorage.removeItem('idleStateDate');
                            this.idleState = 'TIMED_OUT';
                            this.sessionTimeoutService.hideSessionAlert();
                            this.logout();
                            this.cd.detectChanges();
                        }
                    },
                    1000
                );
            } else if (!sessionExpired) {
                if (this.countdown$) {
                    clearInterval(this.countdown$);
                }
                this.countdownStarted = false;
                this.idleState = 'NOT_STARTED';
                this.cd.detectChanges();
            }
        });
    }

    ngOnInit(): void {
        this.wasLoggedInAfterRefresh = this.isReload() && this.hasMsalSession();
        this.translateStrings();
        //  this.sessionTimeoutService.showSessionAlert();
        this.getUserProfile();
        this.router.events.pipe(
            takeUntil(this.destroying$)
        ).subscribe((event) => {
            if (event instanceof NavigationStart) {
                this.toastrService.clear();
            }
        });

        this.loadPage();
        this.reset();
        this.setSessionTimeout(this.lastActiveService);
    }

    translateStrings(){
        let stringsRecord = this.localizeService.loadLocalizedStrings(this.stringLabels);
        this.labels = {...this.labels, ...stringsRecord};
        if (this.labels['leftNav.learn_more']) {
            this.labels['leftNav.learn_more'] = this.labels['leftNav.learn_more'].replace(/'/g, '\u2019');
        }
    }

    getVersionDetails(mode: string) {
        this.shellService.getVersions().pipe(
            takeUntil(this.destroying$)
        ).subscribe((res) => {
            this.webAppVersion = res?.webAppVersionLabel;
            this.ddtVersion = res?.ddtVersionLabel;
            this.vdeVersion = res?.vdeVersionLabel;
            this.openHelpDialogPopup(mode);
        });
    }
    ngAfterViewInit() {
        // Removed duplicate getUserProfile() call - already called in ngOnInit()
        this.oidcService.events
            .pipe(
                filter((e) => e.type === 'session_terminated'),
                takeUntil(this.destroying$)
            )
            .subscribe((e) => {
                this.logout();
            });
        proxy = this;
    }

    ngAfterViewChecked() {
        const elem = this.elementRef.nativeElement.querySelector(
            '.highlight_impersonate'
        ) as HTMLElement | null;

        if (elem && elem !== this.impersonateElement) {
            if (this.impersonateElement) {
                this.impersonateElement.removeEventListener('click', this.onImpersonateClick);
            }
            elem.addEventListener('click', this.onImpersonateClick);
            this.impersonateElement = elem;
        }
    }

    ngOnDestroy(): void {
        this.destroying$.next();
        this.destroying$.complete();
        
        if (this.impersonateElement) {
            this.impersonateElement.removeEventListener('click', this.onImpersonateClick);
            this.impersonateElement = null;
        }
    }

    storePrevUrl() {
        this.currentUrl = this.router.url;
        this.previousUrl = '';
        // Initialize home page flag on load
        this.isHomePage = this.currentUrl.startsWith('/home');

        this.router.events
            .pipe(
                filter((event: any) => event instanceof NavigationEnd),
                takeUntil(this.destroying$)
            )
            .subscribe((event: NavigationEnd) => {
                this.previousUrl = this.currentUrl;
                this.currentUrl = event.urlAfterRedirects;
                const urlObj: RouteChangeObject = {
                    currentUrl: this.currentUrl,
                    prevUrl: this.previousUrl,
                };
                this.routeChangeService.setUrls(urlObj);
                // Update home page flag on every completed navigation
                this.isHomePage = this.currentUrl.startsWith('/home');
            });
    }
    impersonateUser: boolean = false;
    loginAs: string = '';
    loadPage() {
        if (!sessionStorage.getItem('accessToken')) {
            this.router.navigateByUrl('/base');
        }

        this.userService.getUserProfile(false).pipe(
            takeUntil(this.destroying$)
        ).subscribe((userProfile: UserProfileObject) => {
            if (userProfile) {
                this.userProfile = userProfile;
                this.impersonateMessage = this.generateImpersonateMessage(this.userProfile.effectiveUserName, this.userProfile.customerName);
               // this.clinicLanguage = this.userProfile.clinicLanguage;
                this.firstName = this.userProfile?.firstName;
                this.lastName = this.userProfile?.lastName;
                this.impersonateUser = this.userProfile?.impersonatedUser;
                this.userJurisdiction = this.userProfile?.legalJurisdiction;
                this.userName = this.userProfile.displayName;
                this.enableSubMenu = false;
                this.icmDeviceAvailable = this.userProfile.icmDeviceAvailable;
                this.icmAiCapableDeviceAvailable = this.userProfile.icmAiCapableDeviceAvailable;
                this.aiCountryUnlocked = this.userProfile.aiCountryUnlocked;
                this.rpEnabled = this.userProfile.rpEnabled;
                
                // Send clinic name to New Relic for monitoring
                const clinicName = this.userProfile.customerName;
                const newrelic = typeof window !== 'undefined' ? (window as any).newrelic : null;
                
                if (clinicName && newrelic) {
                    newrelic.setCustomAttribute('clinicName', clinicName);
                }
                
                if (this.userProfile.impersonatedUser) {
                    if (this.userProfile.displayName?.includes(',')) {
                        let names = this.userProfile.displayName.split(',');
                        let fname = [names[1].trim()[0], names[0]];
                        this.loginAs = fname.join(' ');
                    } else {
                        this.loginAs = this.userProfile.displayName;
                    }
                }
                // Clinician Flow
                this.role = Role.User;
                this.userService.setUserObs(userProfile);
                this.userService.setRoleObs(Role.User);
                const response = {
                    role: Role.User,
                    user: this.userProfile
                }
                if (this.userProfile.activatorClinicFlg) {
                    this.setActivatorUserMode(response);
                } else {
                    this.setClinicianMode(response);
                }
                this.isSignedOn = true;
                // if(this.clinicLanguage=='zh'){
                //    this.clinicLanguage = 'zh_HANS';
                // }
               // this.shellService.loadTrustArc(this.clinicLanguage);
            } else {
                this.goto('/base');
            }
        })
        // Below Code is not required as we are fetching stored user data
        // this.userService.getRoleObs().subscribe(
        //      (response: any) => {
        //         if (!response.role) {
        //             // verify role with token- fetch user data if not available in observable
        //             console.log('loadPage: getRoleObs: on reload -  checking for token');
        //             this.verifyUserTokenValid();
        //         }
        //     },
        //     (error: any) => {

        //     }
        // );
    }

    setClinicianMode(response: UserRole) {
        (document.body as HTMLElement).classList.add('blue-theme');
        // API returns numeric codes: 10146 (Home) or 10147 (Recent Transmission)
        const landingPagePref = (response.user as any)?.landingPagePreferenceCd;
        
        // Menu order is always fixed: Home > Recent Transmission > Patient List > Tools > Clinic Administration
        this.menuDataSource = [
            {
                url: '/home',
                link: 'label.gb.home',
            },
            {
                url: '/clinician',
                link: 'label.gb.recent_trans',
                hide: response?.user?.activatorClinicFlg,
            },
            {
                url: '/patient-list',
                link: 'label.gb.pat_list',
            },
            {
                url: '/tools',
                link: 'label.gb.tools',
            },
            {
                url: '/clinic-admin',
                link: 'label.gb.clin_administration',
                hide: this.checkHide(response.user.admin),
            },
            {
                url: '/communication-center',
                link: 'title.Communication_Center',
                hide: true, //response?.user?.showCommCenter === false,
            },
        ];
        this.clinicianLocale(response);
        
        const currentUrl = this.router.url;
        const isBaseRoute = currentUrl === '/' || currentUrl === '/base' || currentUrl === '' || currentUrl.startsWith('/base');
        
        if (isBaseRoute) {
            const landingRoute = this.myAccountService.getRouteForPreference(landingPagePref);
            this.router.navigate([landingRoute]);
        }
    }

    checkHide(admin: boolean) {
        if (this.impersonateUser && admin) {
            return false;
        }
        return !admin;
    }

    getLastLogin() {
        let loginTime = this.userProfile?.lastLoginDtm;
        const formattedTime = this.helperService.parseDateTime(
            loginTime,
            true,
            true,
            this.userProfile?.clinicUserTZ,
            this.userProfile?.dateFormat,
            this.userProfile?.timeFormat
        );
        return this.localizeService.generateLocalizedStr(
            'label.gb.lastlogindtm',
            { 0: formattedTime }
        );
    }

    setActivatorUserMode(response: UserRole) {
        (document.body as HTMLElement).classList.add('blue-theme');
        this.menuDataSource = [
            {
                url: '/patient-list',
                link: 'label.gb.pat_list',
            },
            {
                url: '/clinic-admin',
                link: 'label.gb.clin_administration',
                hide: response.user.admin != true,
            },
        ];
        let loggedInAlready = JSON.parse(sessionStorage.getItem('isActivatorLoggedIn') || 'false');
        loggedInAlready === true ? '' : this.goto('/patient-list');
        sessionStorage.setItem('isActivatorLoggedIn', JSON.stringify(true));
        this.clinicianLocale(response);
    }
    private clinicianLocale(response: UserRole) {
        const locale = response?.user?.locale;
        this.localizeService.setLanguage(LanguageSource.UserDefined, locale);
    }

    // private verifyUserTokenValid() {
    //     this.userService.getUserProfile(false).subscribe(
    //         (userData: UserProfileObject) => {
    //             if (userData) {
    //                 this.isSignedOn = true;
    //                 this.userService.setUserObs(userData);
    //                 this.userService.setRoleObs(Role.User);
    //                 //  this.goto('/clinician');
    //                 const response = {
    //                     role: Role.User,
    //                     user: userData
    //                 }
    //                 if (response.user.activatorClinicFlg) {
    //                     this.setActivatorUserMode(response);
    //                 } else {
    //                     this.setClinicianMode(response);
    //                 }
    //             }
    //         },
    //         (err) => {
    //             this.goto('/login');
    //         }
    //     );
    // }

    goto(url: string) {
        this.router.navigateByUrl(url);
    }

    isImpersonatedUser() {
        return (
            this.userProfile?.effectiveUserRecordId > 0 &&
            this.userProfile.userRecordId == 0
        );
    }
    generateImpersonateMessage(effectiveUserName: string, customerName: string) {
        let returnString = this.localizeService.generateLocalizedStr(
            'label.gb.logged_in_as_userid_at_clinicNm_click_to_return',
            {
                0: this.userProfile?.effectiveUserName,
                1: this.userProfile?.customerName,
            }
        ) || '';

        let here;
        /** DMR user footer banner For:
         * German, English, Spanish, Italian, Japanese, Chinese and French */
        returnString.includes('hier')
            ? (here = 'hier')
            : returnString.includes('here')
                ? (here = 'here')
                : returnString.includes('aquí')
                    ? (here = 'aquí')
                    : returnString.includes('qui')
                        ? (here = 'qui')
                        : returnString.includes('ここ')
                            ? (here = 'ここ')
                            : returnString.includes('此处')
                                ? (here = '此处')
                                : returnString.includes('ici')
                                    ? (here = 'ici')
                                    : '';

        returnString = this.highlightText(here || '', returnString);
        return returnString;
    }

    highlightText(text: string, string: string): string {
        var index = string.indexOf(text);
        if (index >= 0) {
            string =
                string.substring(0, index) +
                "<span class='highlight_impersonate' id='impersonate'>" +
                string.substring(index, index + text.length) +
                '</span>' +
                string.substring(index + text.length);
            return string;
        } else {
            return '';
        }
    }
    logout() {
        this.localizeService.getSignOutAction().pipe(first()).subscribe((pendingChanges: boolean) => {
            pendingChanges = this.clinicAdminService.isDirty ? this.clinicAdminService.isDirty :
                this.exportOptionService.isFormDirty ? this.exportOptionService.isFormDirty :
                    this.commonService.isMyAccountFormDirty ? this.commonService.isMyAccountFormDirty :
                        false;
            //no pending changes
            if (!pendingChanges) {
                this.doLogout();
                //pending changes
            } else {
                const dialogConfig: PopupConfig = {
                    type: PopupType.Confirm,
                    message: this.localizeService.generateLocalizedStr('msg.cs834.text', null, 'html') || '',
                    confirmText: this.localizeService.generateLocalizedStr('label.gb.ok') || '',
                    confirmId: 'confirm-on-signout',
                    cancelText: this.localizeService.generateLocalizedStr('label.gb.button_cancel') || '',
                    cancelId: 'cancel-on-signout',
                    customPopup: true,
                };
                this.popupService.open(dialogConfig);
                this.popupService.confirmed().toPromise().then(res => {
                    if (res) {
                        this.localizeService.setSignOutAction(false);
                        this.doLogout();
                    }
                })
            }
        });
    }
    doLogout() {
        // Clear the RP edit-MFA session marker for BOTH logout flows (popup + redirect).
        window.sessionStorage.removeItem('msal-redirect-login-edit');
        if (this.msalGuardConfig.interactionType === InteractionType.Popup) {
            this.msalService.logoutPopup({
                postLogoutRedirectUri: environment.redirectUri,
                mainWindowRedirectUri: environment.redirectUri,
            });
        } else {
            window.sessionStorage.removeItem('MERLIN_USP');
            if (
                this.idleState === 'NOT_STARTED' ||
                this.idleState === 'NOT_IDLE'
            ) {
                // Manual Signout
                this.msalService.logoutRedirect({
                    postLogoutRedirectUri: this.isImpersonatedUser()
                        ? environment.logoutRedirectURI
                        : environment.redirectUri,
                });
            } else {
                //Session timeout
                this.msgStr = this.localizeService.generateLocalizedStr(
                    'msg.cs817.text',
                    'html'
                ) || '';

                let strfy = JSON.stringify({
                    impersonated: this.isImpersonatedUser(),
                    message: this.msgStr,
                    btnLabel: `${this.localizeService.generateLocalizedStr(
                        'label.gb.ok'
                    )}`,
                    messageStr: 'msg.cs817.text',
                    btnStr: 'label.gb.ok',
                    locale: this.userProfile?.locale
                });
                let encodeURICmp = window.encodeURIComponent(strfy);
                this.msalService.logoutRedirect({
                    postLogoutRedirectUri: this.isImpersonatedUser()
                        ? environment.logoutRedirectURI
                        : environment.forceLogoutURI +
                        '?params=' +
                        window.btoa(encodeURICmp),
                });
            }
            /***
             * Reset Primary & Secondary filters
             *  to Default in both RT & patient List page
             */
            // const gridConfig = window.sessionStorage.gridArrayStore; // Enable this if want to revert

            window.sessionStorage.clear();
            // let gridConfigPrse = JSON.parse(gridConfig)?.filter(   // Enable this if want to revert
            //     (d) => d.gridName != 'patient-grid'
            // );
            // window.sessionStorage.gridArrayStore =
            //     JSON.stringify(gridConfigPrse);
            /**--------------------------- */
            this.userService.setRoleObs(null as any);
            this.userService.logoutUser$.next(true);
        }
    }

    myaccount() {
        this.router.navigateByUrl('/my-account');
    }
    reset() {
        this.idleState = 'NOT_IDLE';
        this.sessionTimeoutService.hideSessionAlert();
        this.lastActiveService.resetSessionTimeout();
        this.cd.detectChanges();
    }
    ToHHMMSS(value: any) {
        const secNum = parseInt(value, 10); // don't forget the second param
        let hours: string | number = Math.floor(secNum / 3600);
        let minutes: string | number = Math.floor((secNum - hours * 3600) / 60);
        let seconds: string | number = secNum - hours * 3600 - minutes * 60;

        if (hours < 10) {
            hours = '0' + hours;
        }
        if (minutes < 10) {
            minutes = '0' + minutes;
        }
        if (seconds < 10) {
            seconds = '0' + seconds;
        }
        return hours + ':' + minutes + ':' + seconds;
    }
    openHelpDialog(mode: string) {
        if (mode === 'about')
            this.getVersionDetails(mode);
        else
            this.openHelpDialogPopup(mode)
    }
    openHelpDialogPopup(mode: string) {
        let messageKey: string;
        let messageParams: Record<string, string>;

        if (this.icmDeviceAvailable && this.icmAiCapableDeviceAvailable && this.rpEnabled) {
            if (this.aiCountryUnlocked) {
                messageKey = 'msg.ab001.about_txt_eponly_AI';
            } else {
                messageKey = 'msg.ab001.about_txt_eponly';
            }
            messageParams = {
                0: this.webAppVersion,
                1: this.ddtVersion,
                2: this.vdeVersion,
            };
        } else {
            messageKey = 'msg.ab001.about_txt_eponly_noVDE';
            messageParams = {
                0: this.webAppVersion,
                1: this.ddtVersion,
            };
        }

        const dialogRef = this.dialog.open(helpDialog, {
            data: {
                mode: mode,
                about_txt_eponly: this.localizeService.generateLocalizedStr(
                    messageKey,
                    messageParams,
                    'html'
                ),
            },
            restoreFocus: false,
        });
        dialogRef.afterClosed().subscribe(() => this.menuTrigger?.focus());
    }
    onAdminLearnMoreClick() {
        window.location.href =
            'https://www.cardiovascular.abbott/us/en/hcp/products/heart-failure/pulmonary-pressure-monitors/cardiomems/about.html';
    }

    onAdminHelpClick() {
        window.open('https://www.eifu.abbott', '_blank');
    }
    onLearnMoreClick() {
        window.open(
            'https://www.cardiovascular.abbott/us/en/hcp/products/cardiac-rhythm-management/connectivity-remote-care.html',
            '_blank'
        );
    }
    onHelpClick() {
        window.open('https://www.eifu.abbott', '_blank');
    }
    onHelpOtherLangLink(link: string) {
        window.open(link, '_blank');
    }

    showOtherLanguageHelpLinks() {
        if (this.userProfile?.legalJurisdiction == 'USA') {
            return false;
        } else {
            return true;
        }
    }

    privacyPolicyClick() {
        window.open(
            environment.disclosureUrl + '/Privacy_Policy.pdf',
            '_blank'
        );
    }

    termsAndConditionsClick() {
        if (!proxy.userProfile?.clinicCountry) {
            return false;
        }
        window.open(
            `${environment.disclosureUrl}/ClinicTermsAndConditions/Clinic_Terms_and_Conditions_${proxy.userProfile?.clinicCountry}.pdf`,
            '_blank'
        );
    }

    contactUsClick() {
        const title = 'Contact Information'; // this.translate('label.gb.contact_info');
        var win = window.open(
            '',
            'UATRpt',
            'menubar=0,location=0,toolbar=0,resizable=1,status=1,scrollbars=1'
        );

        if (win && win.document) {
            win.document.write(
                '<html><head><title>' +
                title +
                '</title></head><body><img src="' +
                environment.disclosureUrl +
                '/' +
                'contact_us_text.gif' +
                '" width="70%"></body></html>'
            );
        }
        if (win) {
            win.focus();
        }
    }

    websiteTermsClick() {
        window.open(
            environment.disclosureUrl + '/Terms_and_Conditions.pdf',
            '_blank'
        );
    }

    websiteMoreInfoClick() {
        window.open('https://www.cardiovascular.abbott', '_blank');
    }
    extendClicked() {
        this.reset();
        document.title = 'Merlin.net™ PCN';
        this.sessionTimeoutService.hideSessionAlert();
        this.getNewToken();
    }
    generateScopes() {
        const returnArray: string[] = [];
        environment.scopePermissions.split(' ').forEach((scopeUrl) => {
            returnArray.push(environment.scope + '/' + scopeUrl);
        });
        return returnArray;
    }

    getNewToken() {
        this.msalService
            .acquireTokenSilent({
                scopes: this.generateScopes(),
            } as RedirectRequest)
            .pipe(take(1))
            .subscribe(
                (res: any) => {
                    // console.log('access token: ', res);
                    window.sessionStorage.setItem(
                        'accessToken',
                        res.accessToken
                    );
                    window.sessionStorage.setItem('guid', uuidv4() + '_');
                },
                (err) => {
                    console.log(err);
                }
            );
    }

    userProfile: UserProfileObject | any;
    getUserProfile() {
        this.userService.getUserProfile(false).subscribe((userinfo: any) => {
            let userRecordIdToUse = userinfo.userRecordId ? userinfo.userRecordId : userinfo.effectiveUserRecordId;
            this.myAccountService.view(userRecordIdToUse).subscribe(
                (accountData) => {
                    this.userProfile = {...userinfo, landingPagePreferenceCd: accountData.landingPagePreferenceCd};
                    this.setupUserProfile(this.userProfile);
                },
                () => {
                    this.userProfile = {...userinfo};
                    this.setupUserProfile(this.userProfile);
                }
            );
        });
    }

    private setupUserProfile(userinfo: any) {
        this.impersonateMessage = this.generateImpersonateMessage(this.userProfile.effectiveUserName, this.userProfile.customerName);
        this.impersonateUser = userinfo?.impersonatedUser;
        this.languageHelpLinks =
            userinfo?.helpLanguages.length > 0
                ? userinfo?.helpLanguages?.filter((helpLang: string) => !helpLang.includes('default')).map((lang: string) => {
                    let langKey = lang.split('_')[0];
                    let lngLink = {
                        label: this.translate(
                            `label.header.helpManual.${langKey}.link.text`
                        ),
                        link: userinfo?.helpLinks[lang],
                    };
                    return lngLink;
                })
                : [
                    {
                        label: this.translate(
                            `label.header.helpManual.en.link.text`
                        ),
                        link: 'https://www.eifu.abbott/',
                    },
                ];
        const htmlElement = this.dom.querySelector('html');
        if (htmlElement) {
            htmlElement.setAttribute('locale', this.userProfile.locale);
        }
    }

    async redirectToBase() {
        const redirectUri = !environment.production
            ? window.location.origin + '/impersonate'
            : window.location.origin + '/merlin-cloud/impersonate';
        const redirectConfig: any = {
            ...this.msalGuardConfig.authRequest,
        };
        sessionStorage.clear();
        this.userService.setRoleObs(null);
        this.userService.logoutUser$.next(true);
        this.msalService.loginRedirect({
            scopes: redirectConfig.scopes,
            authority: environment.impersonateAuthority,
            redirectUri: redirectUri,
            prompt: 'login',
            extraQueryParameters: {
                impersonatedUrl: window.btoa(environment.impersonate_url),
            }
        });
    }

    translate(key: string): any {
        return this.localizeService.generateLocalizedStr(key);
    }
    openPracticeSiteData() {
        this.openHelpDialog('practice_site');
    }
    openAboutData() {
        this.openHelpDialog('about');
    }
}

@Component({
    selector: 'help-dialog',
    templateUrl: 'about.html',
    standalone: false
})
export class helpDialog {
    mode: string;
    about_txt_eponly: string;
    userProfileObj: any;
    practiceSiteUserName: string = '';
    practiceSitePassword: string = '';
    practiceSiteLink: string = '';
    allowToDisplay: boolean = false;
    userLegalJurisdiction: string = '';
    userClinicCountry: string = '';
    userClinicCountryCd: number = 0;

    imageMatrix: any = {
        crmManufacturer: ["USA", "TUV", "CAN", "ANZ", "JAP"],
        importerEcRepAbt: ["USA", "TUV", "CAN", "ANZ", "JAP"],
        CEMark: ["USA", "TUV", "CAN", "ANZ", "JAP"],
        medicalDevice: ["USA", "TUV", "CAN", "ANZ", "JAP"],
        consultInstructions: ["USA", "TUV", "CAN", "ANZ", "JAP"],
        chRep: ["USA", "TUV", "CAN", "ANZ", "JAP"],
        rxOnly: ["USA", "TUV", "CAN", "ANZ", "JAP"],
        abbottMedical: []
    }

    chinaImageList = ['crmManufacturer', 'CEMark', 'medicalDevice', 'consultInstructions', 'rxOnly', 'abbottMedical']
    constructor(
        @Inject(MAT_DIALOG_DATA) public data: string,
        private localizeService: LocalizationService,
        private userService: UserService
    ) {
        this.mode = (this.data as any)['mode'];
        this.about_txt_eponly = (this.data as any)['about_txt_eponly'];
    }

    ngOnInit() {
        let allowedLegalJurisdictions = ["TUV", "USA", "JAP", "ANZ", "CAN"];
        let restrictedLegalJurisCountries = ['CN'];
        this.userService
            .getUserProfile(false)
            .subscribe((userProfile: UserProfileObject) => {
                this.practiceSiteLink = userProfile?.practicisteURL || '';
                this.practiceSiteUserName = userProfile?.practicisteLevUserName || '';
                this.practiceSitePassword = userProfile?.practicisteLevPassword || '';
                this.userLegalJurisdiction = userProfile.legalJurisdiction;
                this.userClinicCountry = userProfile.clinicCountry;
                this.userClinicCountryCd = userProfile.clinicCountryCd;
            });

        if (this.mode === 'about') {
            this.setKoreaIfuUrl();
        }
    }

    showRegulatoryImage(imageClassifier: string){
        if(this.userClinicCountry == 'CN'){
            return this.chinaImageList.includes(imageClassifier) ? true : false;
        }

        if(imageClassifier == null){
            return false;
        } else if (imageClassifier in this.imageMatrix){
            let imageJurisdictions = this.imageMatrix[imageClassifier];
            if(imageJurisdictions.includes(this.userLegalJurisdiction)){
                return true;
            } else {
                return false;
            }
        } else {
            return false;
        }
    }

    onPracticeSiteLink() {
        window.open(this.practiceSiteLink, '_blank');
    }

    translate(key: string): any {
        return this.localizeService.generateLocalizedStr(key, null, 'html');
    }

    setKoreaIfuUrl() {
        if (this.userClinicCountry === ClinicCountryEnum.KR && this.userClinicCountryCd === CountryCdEnum.KOREA) {
            this.about_txt_eponly += '<br/><br/>' + CoreConstants.koreaIfuUrl;
        }
    }
}